<div fxLayout="row" fxLayoutAlign="space-between top">
  <span mat-dialog-title>{{ 'user.account' | translate }}</span>
  <button mat-icon-button matDialogClose>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>
<div fxLayout="row" fxLayoutAlign="center">
  @if (isActionPending$ | async) {
    <mat-spinner></mat-spinner>
  }
</div>

@if (!(isActionPending$ | async) && user$ | async) {
  <div>
    <mat-dialog-content>
      <form [formGroup]="userProfileFormGroup" appReadOnlyWithoutPermission="WRITE_OWN_PROFILE">
        <mat-form-field>
          <mat-label>{{ 'user.firstName' | translate }}</mat-label>
          <input matInput type="text" formControlName="firstName">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'user.lastName' | translate }}</mat-label>
          <input matInput type="text" formControlName="lastName">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'user.email' | translate }}</mat-label>
          <input matInput type="email" formControlName="email">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'user.password' | translate }}</mat-label>
          <input
            matInput type="password"
            formControlName="plainPassword"
            >
        </mat-form-field>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button *ngxPermissionsOnly="['WRITE_OWN_PROFILE']" color="accent" [disabled]="userProfileFormGroup.invalid" (click)="persistUser()">
        <mat-icon>check</mat-icon>
        {{ 'user.actions.persist' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
}
